// src/components/common/ConfirmationModal/ConfirmationModal.tsx
import React from 'react';
import { FiX, FiAlertTriangle } from 'react-icons/fi';
import styles from './ConfirmationModal.module.css';

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  variant?: 'danger' | 'default';
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmationModal({
  open,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  loading = false,
  variant = 'default',
  onConfirm,
  onCancel
}: ConfirmationModalProps) {
  if (!open) return null;

  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.iconContainer}>
            {variant === 'danger' ? (
              <FiAlertTriangle className={`${styles.icon} ${styles.iconDanger}`} />
            ) : (
              <FiAlertTriangle className={styles.icon} />
            )}
          </div>
          <h3 className={styles.title}>{title}</h3>
          <button 
            className={styles.closeButton} 
            onClick={onCancel}
            disabled={loading}
          >
            <FiX />
          </button>
        </div>

        <div className={styles.content}>
          <p className={styles.message}>{message}</p>
        </div>

        <div className={styles.footer}>
          <button 
            className={`${styles.button} ${styles.buttonSecondary}`}
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button 
            className={`${styles.button} ${
              variant === 'danger' ? styles.buttonDanger : styles.buttonPrimary
            }`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Procesando...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}